class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
      mediaItem: '[data-media-id]',
      slide: '.swiper-slide[data-media-id]',
      modalOpeners: '[data-modal-opener-id]',
      zoomContainer: '[data-zoom-container]',
      zoomImages: '[data-pswp-image]',
      btnXr: '[data-shopify-xr]',
      withThumbs: '[data-with-thumbs]',
    };

    this.lightbox = null;
    this.slideObserver = null;

    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider).querySelector(
          '[data-selected]'
        )?.dataset.index
      ) || 0;

    const swiperOptions = JSON.parse(
      this.querySelector(this.selectors.slider).getAttribute(
        'data-swiper-options'
      )
    );

    var setWrapperStyles = function (swiper) {
      var wrapperCenterClass = 'swiper-wrapper__center';
      var buttonDisabledClass = swiper.params.buttonDisabledClass;
      var wrapperEl = swiper.wrapper[0];

      if (
        swiper.prevButton[0].classList.contains(
          buttonDisabledClass
        ) &&
        swiper.nextButton[0].classList.contains(buttonDisabledClass)
      ) {
        // center slides
        wrapperEl.classList.add(wrapperCenterClass);
      } else {
        wrapperEl.classList.remove(wrapperCenterClass);
      }
    };

    const thumbSettings = {
      swiper: {
        el: '.swiper-thumbs',

        initialSlide: this.selectedMediaIndex,

        centeredSlides: true,
        centeredSlidesBounds: true,
        // slideToClickedSlide: true,
        freeMode: {
          enabled: true,
          sticky: true
        },
        direction: 'horizontal',

        slidesPerView: 6,
        spaceBetween: 2,

        threshold: 5,

        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,

        breakpoints: {
          750: {
            direction: swiperOptions.thumbsDirectionDesktop,
            spaceBetween: 5
          }
        },

        on: {
          touchEnd: function(s,e) {
            let range = 5;
            let diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY
                        - s.touches.startY
            if (diff < range || diff > -range) s.allowClick = true;
          }
        }
      }
    };

    this.settings = {
      sliderElement: this.querySelector(this.selectors.slider),
      sliderInstance: null,
      options: {
        // open on the variant's media, not the first slide
        initialSlide: this.selectedMediaIndex,
        navigation: {
          prevEl: this.querySelector('.swiper-button--prev'),
          nextEl: this.querySelector('.swiper-button--next')
        },

        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar'
        },

        watchOverflow: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,

        autoHeight: this.dataset.autoHeight === 'true',

        spaceBetween: 2,

        breakpoints: {
          990: {
            slidesPerView: swiperOptions.slidesPerViewDesktop
          }
        },

        thumbs: thumbSettings,
        on: {
          // show thumbs after 10ms delay
          init: swiper => {
            setTimeout(() => {
              swiper.thumbs.swiper.el.classList.add(
                'swiper-thumbs--visible'
              );
            }, 10);
          },
          afterInit: swiper => {
            const slide =
              swiper.slides[this.selectedMediaIndex] || swiper.slides[0];
            if (!slide) return;

            const video = slide.querySelector('video');
            if (video) video.play();

            const youtube = slide.querySelector('.js-youtube');
            if (youtube) this.playYoutubeVideo(youtube);

            const vimeo = slide.querySelector('.js-vimeo');
            if (vimeo) this.playVimeoVideo(vimeo);
          },
          slideChangeTransitionStart: swiper => {
            // thumbs slideTo main active index
            const thumbsSwiper = swiper.thumbs.swiper;
            const activeIndex = swiper.activeIndex;
            const thumbsActiveIndex = thumbsSwiper.activeIndex;
            if (activeIndex !== thumbsActiveIndex) {
              thumbsSwiper.slideTo(activeIndex);
            }
          },
          slideChangeTransitionEnd: swiper => {
            this.setActiveModalOpener(swiper);
          },
          transitionStart: swiper => {
            const videos = swiper.el.querySelectorAll('video');
            Array.from(videos).forEach(video => {
              video.pause();
            });
          },
          transitionEnd: swiper => {
            let slideIndex = swiper.activeIndex;
            const swiperCardWidth = swiper.slides[0].offsetWidth;
            slideIndex = Math.abs(
              Math.floor(swiper.translate / [swiperCardWidth])
            );
            if (slideIndex !== 0) {
              slideIndex = slideIndex - 1;
            }
            const activeSlide = Array.from(swiper.slides).find(
              sliderSlide =>
                sliderSlide.classList.contains('swiper-slide-active')
            );
            if (!activeSlide) return;

            // play or pause videos in active and next slides
            const activeSlideVideo =
              activeSlide.querySelector('video');
            const nextSlideVideo =
              activeSlide.nextElementSibling?.querySelector('video');

            const playVideo = video => {
              if (video && video.paused) {
                video.play();
              } else if (video) {
                video.pause();
              }
            };

            playVideo(activeSlideVideo);
            playVideo(nextSlideVideo);

            const activeSlideYoutube =
              activeSlide.querySelector('.js-youtube');
            if (activeSlideYoutube) {
              this.playYoutubeVideo(activeSlideYoutube);
            }

            const activeSlideVimeo =
              activeSlide.querySelector('.js-vimeo');
            if (activeSlideVimeo) {
              this.playVimeoVideo(activeSlideVimeo);
            }
          }
        }
      }
    };
  }

  playYoutubeVideo(element) {
    element.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
  }

  playVimeoVideo(element) {
    element.contentWindow.postMessage('{"method":"play"}', '*');
  }

  connectedCallback() {
    this.init();
  }

  /**
   * The gallery is replaced wholesale when the variant changes, so the element
   * cleans up after itself — otherwise every colour change leaks a Swiper
   * instance, a thumb instance, and a PhotoSwipe lightbox bound to detached
   * nodes.
   */
  disconnectedCallback() {
    if (this.slideObserver) {
      this.slideObserver.disconnect();
      this.slideObserver = null;
    }
    if (this.settings.sliderInstance) {
      this.settings.sliderInstance.destroy(true, true);
      this.settings.sliderInstance = null;
    }
    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }
  }

  init() {
    const [zoomContainerWidth, zoomContainerHeight, closeIcon] = [
      this.offsetWidth,
      this.offsetHeight,
      this.querySelector('[data-close-icon]')
    ];

    function isPhone() {
      return window.innerWidth < 750;
    }

    this.lightbox = new PhotoSwipeLightbox({
      gallery: this.selectors.zoomImages,
      appendToEl: this.querySelector(this.selectors.zoomContainer),

      initialZoomLevel: (zoomLevelObject) => {
        if (isPhone()) {
          return zoomLevelObject.vFill;
        } else {
          return zoomLevelObject.fill;
        }
      },
      secondaryZoomLevel: (zoomLevelObject) => {
        if (isPhone()) {
          return zoomLevelObject.fit;
        } else {
          return 1;
        }
      },
      maxZoomLevel: 2,
      getViewportSizeFn: function (options, pswp) {
        return {
          x: zoomContainerWidth,
          y: zoomContainerHeight
        };
      },
      pswpModule: PhotoSwipe
    });
    this.lightbox.addFilter(
      'uiElement',
      (element, data) => {
        if (data.name === 'close' && closeIcon) {
          element.innerHTML = closeIcon.innerHTML;
        }
        return element;
      }
    );

    this.lightbox.init();
    if (!this.settings.sliderElement) return;

    this.settings.sliderInstance = new Swiper(
      this.settings.sliderElement,
      this.settings.options
    );

    this.settleOnSelectedSlide();
  }

  /**
   * initialSlide measures before the images have layout and lands on 0 at this
   * slide count. Re-measure and move once the target slide's image reports a
   * size, rather than counting frames — with a large gallery, layout can take
   * longer than any fixed number of them.
   */
  settleOnSelectedSlide() {
    const swiper = this.settings.sliderInstance;
    const target = this.selectedMediaIndex;
    if (!swiper || swiper.destroyed || target === 0) return;

    const move = () => {
      if (!this.settings.sliderInstance || this.settings.sliderInstance.destroyed) return;
      this.settings.sliderInstance.update();
      this.settings.sliderInstance.slideTo(target, 0, false);
      this.settings.sliderInstance.thumbs?.swiper?.slideTo(target, 0, false);
    };

    move();

    const slide = swiper.slides[target];
    const image = slide?.querySelector('img');

    if (image && !image.complete) {
      image.addEventListener('load', move, { once: true });
      image.addEventListener('error', move, { once: true });
    }

    if ('ResizeObserver' in window && slide) {
      const observer = new ResizeObserver(() => {
        if (!this.settings.sliderInstance || this.settings.sliderInstance.destroyed) {
          observer.disconnect();
          return;
        }
        if (this.settings.sliderInstance.activeIndex !== target) move();
      });
      observer.observe(slide);
      this.slideObserver = observer;
      setTimeout(() => observer.disconnect(), 3000);
    }
  }

  /**
   * Move the gallery to the slide for a given media id.
   *
   * Scoped to slides inside [data-slider] — the bare [data-media-id] selector
   * also matches zoom openers and modal-opener buttons, which carry no
   * data-index, producing slideTo(NaN) and no movement.
   */
  setActiveMedia(id) {
    const mediaId = Number(id);
    if (Number.isNaN(mediaId)) return;

    const slider = this.querySelector(this.selectors.slider);
    if (!slider || !this.settings.sliderInstance) return;

    const mediaFound = Array.from(
      slider.querySelectorAll(this.selectors.slide)
    ).find(media => Number(media.dataset.mediaId) === mediaId);
    if (!mediaFound) return;

    const index = Number(mediaFound.dataset.index);
    if (Number.isNaN(index)) return;

    slider.querySelectorAll(this.selectors.slide).forEach(slide => {
      slide.toggleAttribute(
        'data-selected',
        Number(slide.dataset.mediaId) === mediaId
      );
    });

    this.selectedMediaIndex = index;
    this.settings.sliderInstance.update();
    this.settings.sliderInstance.slideTo(index, 0, false);
    this.settings.sliderInstance.thumbs?.swiper?.slideTo(index, 0, false);

    if (this.settings.sliderInstance.activeIndex !== index) {
      this.settleOnSelectedSlide();
    }
  }

  setActiveModalOpener(swiper) {
    const activeSlide = swiper.slides.filter(sliderSlide =>
      sliderSlide.classList.contains('swiper-slide-active')
    )[0];
    if (!activeSlide) return;
    const activeMediaId = activeSlide.dataset.mediaId;
    this.querySelector(
      `${this.selectors.modalOpeners}.is-active`
    )?.classList.remove('is-active');
    this.querySelector(
      `${this.selectors.modalOpeners} [data-media-id="${activeMediaId}"]`
    )?.parentElement.classList.add('is-active');

    const isModel = activeSlide.dataset.mediaType === 'model';

    if (!isModel) return;

    const btnXr = this.querySelector(this.selectors.btnXr);
    if (btnXr) btnXr.dataset.shopifyModel3dId = activeMediaId;
  }
}

customElements.define('product-media', ProductMedia);